import React from 'react';

const NotFound = () => {
    return <h2>Login Page</h2>;
}

export default NotFound;